import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class F7205Service {

  constructor(private http: HttpClient) { }

  fetchF7205Details(baseUrl: string, rowData: any, sso_id: string, scenario: string, globalService: any): Observable<any> {
    const jcd_key = rowData.JCD_KEY || 250;
    const params = {
      "action_code": 'mnu1s1',
      "sso_id": sso_id,
      "tax_year": rowData.TAX_YEAR,
      "scenario": scenario,
      "jcd_key": jcd_key,
      "combination_key": rowData.COMBINATION_KEY,
      "jcd_ta_key": null,
      "issue_key": rowData.ISSUE_KEY
    };

    const url = `${baseUrl}/loadJsonObject`;
    
    // Build request with globalService params merged
    let requestParams = _.merge({}, globalService?.globalParams || {}, params);
    
    const urlEncoded = new URLSearchParams();
    Object.keys(requestParams).forEach(key => {
      if (requestParams[key] !== undefined && requestParams[key] !== null) {
        urlEncoded.set(key, requestParams[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }

  saveForm7205(
    baseUrl: string,
    final_data: any[],
    clob_settings: any[],
    globalService: any,
    filterParams: any = {},
    rowData: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=jsir53`;
    
    const json_settings = JSON.stringify(clob_settings);
    const json_data = JSON.stringify(final_data);
    
    // Build payload exactly like AngularJS
    let params = _.merge({}, globalService?.globalParams || {}, filterParams);
    params = _.extend({ json_data: json_data }, params);
    params = _.extend({ json_settings: json_settings }, params);
    params.process_name = "form-7205-save";

    // Include checkLockedbj from rowData (NOT hardcoded)
    const checkLockedbj = [{
      "leid": rowData.LEID,
      "me_code": rowData.ME_CODE,
      "cdr_number": rowData.CDR_NO,
      "consol_group_key": rowData.CONSOL_GROUP_KEY,
      "reporting_period": rowData.REPORTING_PERIOD,
      "combination_key": rowData.COMBINATION_KEY,
      "scenario_key": parseInt(filterParams.scenario || params.scenario || '74')
    }];
    params.checkLockedbj = JSON.stringify(checkLockedbj);

    // Add scenarioCode and is_issue_key_enabled if missing (matching AngularJS)
    if (!params.scenarioCode) {
      params.scenarioCode = rowData.SCENARIO_TYPE_CODE || 'RAF';
    }
    
    if (!params.is_issue_key_enabled) {
      params.is_issue_key_enabled = 'N';
    }

    // Convert params to URLSearchParams for form-urlencoded format
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true });
  }
}

